<template>
    <div>
        <b-row>
            <b-col md="12">
                <b-card>
                    <b-table
                        :empty-filtered-text="$t('no_result')"
                        :empty-text="$t('no_result')"
                        bordered
                        striped
                        responsive
                        :items="tableData"
                        :fields="tableFields"
                        show-empty
                        class="mb-5 mt-2 table-dropdown no-scrollbar border rounded">
                        <template #cell(buttons)="row">
                            <i class="ri-stack-line"></i>
                        </template>
                    </b-table>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
// Components

// Services
import EctsService from "@/services/EctsService"

// Other

export default {
    components: {

    },
    props: {
        course: {
            type: Object,
        },
    },
    data() {
        return {
            tableData: [],
            tableFields: [
                {
                    key: 'buttons',
                    label: ''
                },
                {
                    key: 'course.code',
                    label: this.$t('course_code')
                },
                {
                    key: this.getLocaleField('course.name'),
                    label: this.$t('course_name')
                },
                {
                    key: 'course.language',
                    label: this.$t('language')
                },
                {
                    key: 'course.theoretical_credit',
                    label: this.$t('theoretical')
                },
                {
                    key: 'course.practical_credit',
                    label: this.$t('practical')
                },
                {
                    key: 'course.credit',
                    label: this.$t('credit')
                },
                {
                    key: 'course.ects_credit',
                    label: this.$t('ects')
                },
            ],
        };
    },
    created() {
        this.getData()
    },
    methods: {
        getData(){
            EctsService.getProgramCoordinatorElectiveCourses(this.course.data.slot_type).then(response => {
                this.tableData = response.data.data[0].elective_courses
            }).catch(e => {
                this.showErrors(e, null)
            })
        }
    }
}
</script>
